import Attach from '../../../_00_elements/tools/attach';
import eventBus from '../../../_00_elements/tools/event-bus';
import { showSubmitLoader } from '../../../_01_atoms/spinner';

/**
 * User profile manage page
 */
export default function () {
  if (document.querySelectorAll('.user-manage-page').length) {
    Attach.onClickEvent('delete-account-cta', () => {
      eventBus.dispatchEvent(new Event('show-delete-modal'));
    });
  }

  const notifications = document.querySelector('.notifications');

  if (notifications) {
    notifications.querySelector('form').addEventListener('submit', () => {
      showSubmitLoader(notifications.querySelector('button'));
    });
  }
}
